import { isFunction } from 'lodash';

import { Button } from '@/components/button';
import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

export interface SchedulesNoResultsProps {
  message?: string;
  secondaryMessage?: string;
  imagePath?: string;
  buttonText?: string;
  className?: string;
  onButtonClick?: () => void;
}

const SchedulesNoResults = ({
  message = 'No results found that matched your filters.',
  secondaryMessage = 'Try updating your selections, or',
  imagePath = '/assets/question-marker.png',
  buttonText = 'clear filters',
  onButtonClick,
  className,
}: SchedulesNoResultsProps) => {
  const hasClickEvent = isFunction(onButtonClick);

  const { base, imageIcon, button, primaryText, secondaryText } = styles();

  return (
    <div className={base({ className })}>
      <span className={imageIcon()} style={{ backgroundImage: `url(${imagePath})` }} />
      <div>
        <Text className={primaryText()}>{message}</Text>
        <Text className={secondaryText()}>
          {secondaryMessage}{' '}
          {hasClickEvent && buttonText && (
            <Button variant="link" className={button()} onClick={onButtonClick}>
              {buttonText}
            </Button>
          )}
        </Text>
      </div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'mt-2 flex items-center gap-4 px-8 py-6 leading-tight',
    imageIcon: 'block h-12 w-12 bg-contain',
    button: 'text-lightBlue-500 hover:text-lightBlue-700',
    primaryText: 'm-0 mb-2 text-baseSm font-medium',
    secondaryText: 'm-0 text-baseSm italic text-text-secondary',
  },
});

export { SchedulesNoResults };
